// stores/auth.ts
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth',
  () => {
    // State
    const token = ref<string | null>(localStorage.getItem('authToken'))
    const tokenExpiresAt = ref<number | null>(
      localStorage.getItem('authTokenExpiresAt')
        ? Number(localStorage.getItem('authTokenExpiresAt'))
        : null,
    )
    const user = ref<string | null>(null)

    function setTokenExpiration(expiration: number | null) {
      tokenExpiresAt.value = expiration
      if (expiration) {
        localStorage.setItem('authTokenExpiresAt', expiration.toString())
      } else {
        localStorage.removeItem('authTokenExpiresAt')
      }
    }

    function decodeExpirationFromToken(jwt: string): number | null {
      try {
        const [, payload] = jwt.split('.')
        if (!payload) {
          return null
        }
        const normalized = payload.replace(/-/g, '+').replace(/_/g, '/')
        const padding = normalized.length % 4 === 0 ? '' : '='.repeat(4 - (normalized.length % 4))
        const decoded = atob(normalized + padding)
        const data = JSON.parse(decoded)

        if (typeof data.exp === 'number') {
          return data.exp * 1000
        }
      } catch (error) {
        console.warn('Failed to decode JWT expiration', error)
      }
      return null
    }

    // Actions
    function setToken(newToken: string | null) {
      token.value = newToken
      if (newToken) {
        localStorage.setItem('authToken', newToken)
        const expiration = decodeExpirationFromToken(newToken)
        setTokenExpiration(expiration)
      } else {
        localStorage.removeItem('authToken')
        setTokenExpiration(null)
      }
    }

    function setUser(newUser: string | null) {
      user.value = newUser
      if (newUser) {
        localStorage.setItem('currentUser', JSON.stringify(newUser))
      } else {
        localStorage.removeItem('currentUser')
      }
    }


    function clear() {
      setToken(null)
      setUser(null)
      setTokenExpiration(null)
    }

    return {
      token,
      tokenExpiresAt,
      user,
      setToken,
      setUser,
      setTokenExpiration,
      clear,
    }
  },
  {
    persist: {
      key: 'authStore',
      storage: localStorage,
    },
  },
)